import { PlaybackPolicy } from '@shared/interfaces/assistantScript';
import { PolicyOption } from './interfaces';

export const POLICIES: PolicyOption[] = [
  {
    id: PlaybackPolicy.ALWAYS,
    icon: '🔄',
    name: 'Always',
    desc: 'Plays every time the user enters the area',
    color: '#7c3aed',
    bg: '#f5f3ff',
  },
  {
    id: PlaybackPolicy.ONCE_SESSION,
    icon: '⭐',
    name: 'Once per session',
    desc: 'First entry per session — repeats on new sessions',
    badge: 'DEFAULT',
    color: '#2563eb',
    bg: '#eff6ff',
  },
  {
    id: PlaybackPolicy.ONCE_USER,
    icon: '👤',
    name: 'Once per experience',
    desc: 'Plays only the very first time the user ever enters',
    color: '#059669',
    bg: '#ecfdf5',
  },
  {
    id: PlaybackPolicy.FIRST_TIME,
    icon: '🆕',
    name: 'First-time users only',
    desc: "Only during the user's very first session across any experience",
    color: '#d97706',
    bg: '#fffbeb',
  },
];
